import { EntityService } from '../../../service/EntityService';

export class PetrolimexLogService extends EntityService {

  static entity = 'app/petrolog';

  static search(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/search`, data).then(res => res.data);
  }

  static createInvoice(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/invoice`, data).then(res => res.data);
  }

  static createGroupLog(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/group-log`, data).then(res => res.data);
  }

  static putInvoice(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/invoice`, data).then(res => res.data);
  }

  static downloadReportExcel(type: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/report-${type}`, data, { responseType: 'arraybuffer' }).then(res => res.data);
  }

  static printLog(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/print-log`, data).then(res => res.data);
  }

  static printPaymentLog(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/print-payment-log`, data).then(res => res.data);
  }

  static updateInvoiceNo(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/update-invoice-no`, data).then(res => res.data);
  }

  static createCancelLog(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/cancel-log`, data).then(res => res.data);
  }

  static logOffset(id: string): Promise<any> {
    return this.axios.put(`${this.entity}/offset`, { id }).then(res => res.data);
  }

}
